import React from 'react';
import _ from 'lodash';
import Moment from 'moment';
import ReactDropDownCalender from '../ReactDropDownCalender';
import ImageUtility from '../../utilities/imageUtility';
import { SafetyDiaryService } from '../../services/SafetyDiaries';
import {
  RECOVERY_FLAG,
  APPROVAL_STATUS,
  SAFETY_DIARY_IMAGE_MAX_SIZE,
  FLAG_STAUS,
  DIRECT_STATUS_CODE,
} from '../../utilities/constants';
import SafetyDiariesConstants from '../../utilities/safetyDiariesConstants';
import { isNullOrEmpty } from '../../utilities/stringUtil';
import {
  FormList,
  FormElement,
  FormListItem,
  FormListItemGroup,
  FormListItemChild,
} from '../CommonFormComponents';
import { TrashIcon } from '../icons/TrashIcon';
import DropdownSelector from '../dropdowns/DropdownSelector';
Moment.locale('ja');

// form specified constants
// upload image max count
const maxImageCount = 4;

export const SafetyDiaryRecoveryFormData = {
  recovery_date: Moment().format('YYYY/MM/DD'),
  recovery_contents: '',
  recovery_flag: '1',
  recovery_user_id: '1',
  recovery_image1: '',
  recovery_image2: '',
  recovery_image3: '',
  recovery_image4: '',
  recovery_user_name: '',
  recovery_update_time: null,
  approval_user_name: '',
  finish_date: null,
};

export class SafetyDiaryRecoveryForm extends React.Component {
  constructor(props) {
    super(props);

    // 前の画面で残る対策
    SafetyDiaryRecoveryFormData.recovery_contents = '';
    SafetyDiaryRecoveryFormData.report_send_external_service_cooperation = 0;
    SafetyDiaryRecoveryFormData.report_lw_talkroom_ids = [];
    SafetyDiaryRecoveryFormData.report_direct_talkroom_ids = [];

    this.state = {
      fieldId: props.fieldId || sessionStorage.getItem('field_id'),
      uploadImages: [],
      preview: this.props.preview || false, // 閲覧モード(承認用)
      dataId: props.dataId,
      formData: SafetyDiaryRecoveryFormData,
      isWithdrawalApproval: false, // 取り下げ承認フラグ
      isMultiFileSizeError: false, // 複数ファイル_サイズチェック用フラグ
    };

    this.handleRemoveImage = this.handleRemoveImage.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.fileInput = React.createRef();
    this.initedLwTalkRoom = false;
    this.initedDirectTalkRoom = false;
  }

  processInitialImage(formData) {
    if (!formData) {
      return [];
    }
    let defaultUploadedImage = [];
    for (let i = 0; i < maxImageCount; i++) {
      if (
        !isNullOrEmpty(formData[`recovery_image${i + 1}`]) &&
        formData[`recovery_image${i + 1}`]
      ) {
        defaultUploadedImage.push({
          id: i,
          file: formData[`recovery_image${i + 1}`],
          url: formData[`recovery_image_url${i + 1}`],
        });
      }
    }
    return defaultUploadedImage;
  }

  componentDidMount() {
    if (!this.state.preview) {
      this.fileInput.current.addEventListener('change', e => {
        this.handleFileSelected(e.target.files[0]);
        e.target.value = '';
      });
    }
    // 更新時
    if (this.state.dataId) {
      this.loadDiary();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dataId !== this.props.dataId) {
      this.loadDiary();
    }

    if (prevState.uploadImages !== this.state.uploadImages) {
      // this.state.uploadImagesが更新されたらフォーム用のデータを更新する
      this.updateImagesInFormData();
    }

    if (prevState.formData !== this.state.formData) {
      this.props.onUpdate(this.state.formData);
    }
    if (!this.state.preview) {
      this.initLwTalkRoomIds();
      this.initDirectTalkRoomIds();
    }
  }

  loadDiary = () => {
    const params = this.props.params || {
      date_type: SafetyDiariesConstants.dataType.entriesDate,
    };
    SafetyDiaryService.getDiary(
      this.state.fieldId,
      this.state.dataId,
      params
    ).then(response => {
      if (!response.result) {
        alert('データの読み込みに失敗しました。');
        return;
      }
      const safetyDiary = response.data.entities.safety_diary;
      const fixDateFormData = safetyDiary.recovery_date
        ? { ...safetyDiary }
        : { ...safetyDiary, recovery_date: Moment().format('YYYY/MM/DD') };
      const uploadImages = this.processInitialImage(fixDateFormData);
      let isWithdrawalApproval = false;
      if (
        safetyDiary.recovery_flag === RECOVERY_FLAG.incomplete.id &&
        safetyDiary.finish_flag === APPROVAL_STATUS.approval.id
      ) {
        isWithdrawalApproval = true;
      }

      this.setState({
        formData: fixDateFormData,
        uploadImages,
        isWithdrawalApproval,
      });
    });
  };

  async handleFileSelected(file) {
    if (this.state.uploadImages.length >= maxImageCount) {
      return;
    }

    const { maxFileSize } = SafetyDiariesConstants;
    const uploadFileCount = this.state.uploadImages.length + 1;
    const useMaxfileSize =
      uploadFileCount === 1 ? maxFileSize.single : maxFileSize.multi;
    const isValidType = await ImageUtility.fileTypeCheck(file);
    const isValidSize = await ImageUtility.dynamicFileSizeCheck(
      file,
      useMaxfileSize
    );

    if (!isValidType) {
      this.props.onVisibleDialog('errorfileType');
      return;
    }
    if (!isValidSize || this.state.isMultiFileSizeError) {
      this.props.onVisibleDialog('errorfileSize');
      return;
    }
    // 複数ファイルを設定した場合、1枚目がエラーにならないかを事前にチェック
    if (isValidSize && uploadFileCount === 1) {
      this.setState({ isMultiFileSizeError: file.size > maxFileSize.multi });
    }

    const reader = new FileReader();
    reader.onload = async event => {
      const currentFiles = this.state.uploadImages;
      const dataUrl = await ImageUtility.resizeImageBySize(
        event.target.result,
        SAFETY_DIARY_IMAGE_MAX_SIZE,
        file.type
      );
      const renew = currentFiles.concat({
        id: this.state.uploadImages.length,
        file: dataUrl,
        url: '',
      });
      return this.setState({ uploadImages: renew });
    };
    reader.readAsDataURL(file);
  }

  handleFormChange = e => {
    const renew = _.assign({}, this.state.formData, {
      [e.target.name]: e.target.value,
    });
    this.setState({ formData: renew });
  };

  handleCalenderChange = (id, date) => {
    const renew = _.assign({}, this.state.formData, { [id]: date });
    this.props.validate(id, date);
    this.setState({ formData: renew });
  };

  handleRemoveImage = (e, imageId) => {
    const uploadImages = _.cloneDeep(this.state.uploadImages);
    // recalc index
    const newImages = _.map(
      _.remove(uploadImages, image => image.id !== imageId),
      (image, i) => ({ file: image.file, id: i, url: image.url })
    );
    if (imageId === 0) {
      this.setState({ isMultiFileSizeError: false });
    }
    this.setState({ uploadImages: newImages });
  };

  updateImagesInFormData() {
    const prefix = 'recovery_image';
    const uploadImages = this.state.uploadImages;
    let renew = _.cloneDeep(this.state.formData);
    for (let i = 0; i < maxImageCount; i++) {
      renew = {
        ...renew,
        [prefix.concat(i + 1)]: uploadImages[i] ? uploadImages[i].file : '',
      };
    }
    this.setState({ formData: renew });
  }

  renderRecoveryImage = image => {
    return (
      <div className='img-patrol'>
        <div className='img-patrol__inner'>
          <img
            src={image.url === '' ? image.file : image.url}
            alt={`${image.id}`}
          />
        </div>
        {!this.state.preview && (
          <button
            id={image.id}
            className='btn-icon form-list__element--btn_delete'
            onClick={e => this.handleRemoveImage(e, image.id)}
          >
            <TrashIcon className='icon--2_4x form-list__trash-icon' />
          </button>
        )}
      </div>
    );
  };

  renderAddRecoveryImageButton = () => {
    // DOMが消えるとイベントハンドラも消える
    // if (this.state.uploadImages.length >= maxImageCount) { return }
    const uid = _.uniqueId;
    return (
      <div
        className='patrol-image__footer'
        style={
          this.state.uploadImages.length >= maxImageCount
            ? { display: 'none' }
            : null
        }
      >
        <label htmlFor={`upload-${uid}`} className='btn--sub'>
          画像を追加する
        </label>
        <input
          id={`upload-${uid}`}
          name={`upload-${uid}`}
          type='file'
          ref={this.fileInput}
          style={{ display: 'none' }}
          accept='image/png,image/jpeg,image/gif'
        />
        <span className='patrol-image__footer-info'>{`※最大${maxImageCount}枚まで`}</span>
      </div>
    );
  };

  renderRecoveryImageField = () => {
    return (
      <div className='patrol-image'>
        {!_.isEmpty(this.state.uploadImages) && (
          <div className='patrol-image__image'>
            {_.map(this.state.uploadImages, this.renderRecoveryImage)}
          </div>
        )}
        {!this.state.preview && this.renderAddRecoveryImageButton()}
      </div>
    );
  };

  renderRecoveryDateField = () => {
    return (
      <FormListItem label='是正報告日'>
        <FormElement
          validate={this.props.errors && this.props.errors.recovery_date}
        >
          {!this.state.preview && (
            <ReactDropDownCalender
              onChange={date =>
                this.handleCalenderChange('recovery_date', date)
              }
              value={this.state.formData.recovery_date}
            />
          )}
          {this.state.preview &&
            !this.state.isWithdrawalApproval &&
            !_.isNull(this.state.formData.recovery_date) && (
              <p>
                {Moment(this.state.formData.recovery_date).format('YYYY/MM/DD')}
              </p>
            )}
        </FormElement>
      </FormListItem>
    );
  };

  renderRecoveryContentsField = () => {
    return (
      <FormListItem label='是正内容' required={!this.state.preview}>
        <FormElement validate={_.get(this.props, 'errors.recovery_contents')}>
          {this.state.preview ? (
            <span>{this.state.formData.recovery_contents || ''}</span>
          ) : (
            <textarea
              name='recovery_contents'
              maxLength={1024}
              value={this.state.formData.recovery_contents || ''}
              onChange={this.handleFormChange}
              onBlur={e => this.props.validate(e.target.name, e.target.value)}
              disabled={this.state.preview}
            />
          )}
        </FormElement>
      </FormListItem>
    );
  };

  renderRecoveryUserField = () => {
    return (
      <FormListItem label='登録者'>
        <FormElement>{this.state.formData.recovery_user_name}</FormElement>
      </FormListItem>
    );
  };

  renderRecoveryUpdateTimeField = () => {
    return (
      <FormListItem label='登録日時'>
        <FormElement>
          {this.state.formData.recovery_update_time !== null
            ? Moment(this.state.formData.recovery_update_time).format(
                'YYYY/MM/DD(ddd) HH:mm:ss'
              )
            : ''}
        </FormElement>
      </FormListItem>
    );
  };

  renderApprovalUserField = () => {
    return (
      <FormListItem label='是正承認者'>
        <FormElement>{this.state.formData.approval_user_name}</FormElement>
      </FormListItem>
    );
  };

  renderFinishDateField = () => {
    return (
      <FormListItem label='是正承認日'>
        <FormElement>
          {this.state.formData.finish_date !== null
            ? Moment(this.state.formData.finish_date).format('YYYY/MM/DD')
            : ''}
        </FormElement>
      </FormListItem>
    );
  };

  initLwTalkRoomIds = () => {
    if (
      !_.isEmpty(this.props.lwTalkRooms) &&
      !this.initedLwTalkRoom &&
      !_.isEmpty(this.state.formData.report_lw_talkroom_ids)
    ) {
      this.initedLwTalkRoom = true;
      const reportLwTalkroomIds = _.map(
        this.state.formData.report_lw_talkroom_ids,
        talkRoomId => String(talkRoomId)
      );
      const lwTalkRooms = _.map(this.props.lwTalkRooms, room =>
        String(room.id)
      );
      this.setState({
        formData: {
          ...this.state.formData,
          report_lw_talkroom_ids: _.intersection(
            reportLwTalkroomIds,
            lwTalkRooms
          ),
        },
      });
    }
  };

  initDirectTalkRoomIds = () => {
    if (
      !_.isEmpty(this.props.directTalkRooms) &&
      !this.initedDirectTalkRoom &&
      !_.isEmpty(this.state.formData.report_direct_talkroom_ids)
    ) {
      this.initedDirectTalkRoom = true;
      const listAllDirectRoomId = _.map(
        this.props.directTalkRooms,
        directRoom => directRoom.talk_id
      );
      this.setState({
        formData: {
          ...this.state.formData,
          report_direct_talkroom_ids: _.intersection(
            this.state.formData.report_direct_talkroom_ids,
            listAllDirectRoomId
          ),
        },
      });
    }
  };

  toggleSendExternalServiceCooperation = event => {
    const flag = event.target.value;
    let toggle;
    if (flag === String(FLAG_STAUS.negative.id)) {
      toggle = FLAG_STAUS.positive.id;
    } else {
      toggle = FLAG_STAUS.negative.id;
    }
    this.setState(
      prevState => ({
        formData: {
          ...prevState.formData,
          report_send_external_service_cooperation: toggle,
          report_lw_talkroom_ids: [],
          report_direct_talkroom_ids: [],
        },
      }),
      () => {
        this.props.validate('report_send_external_service_cooperation', toggle);
      }
    );
  };

  handleSelectRoom = (name, roomIds = []) => {
    const formData = _.cloneDeep(this.state.formData);
    formData[name] = roomIds;
    this.setState(
      {
        formData,
      },
      () => {
        this.props.validate(name, formData);
      }
    );
  };

  renderNotificationLwField = () => {
    const uid = _.uniqueId();
    const {
      formData: { report_send_external_service_cooperation },
    } = this.state;
    const { line_works, direct } = this.props.externalServiceCooperationStatus;
    const isShowField =
      line_works.available ||
      direct.available ||
      direct.reason_code === DIRECT_STATUS_CODE.UNAVAILABLE;
    return (
      isShowField && (
        <React.Fragment>
          <FormListItem
            label='チャット通知設定'
            isBorder={!report_send_external_service_cooperation}
          >
            <FormElement info='選択対象のトークルームに対して通知メッセージを送信します。'>
              <label htmlFor={`checkbox-2-102${uid}`} className='checkbox'>
                <input
                  type='checkbox'
                  name='report_send_external_service_cooperation'
                  value={report_send_external_service_cooperation}
                  checked={
                    Number(report_send_external_service_cooperation) ===
                    FLAG_STAUS.positive.id
                  }
                  onChange={this.toggleSendExternalServiceCooperation}
                  id={`checkbox-2-102${uid}`}
                />
                <i className='i-square i-3x' aria-hidden='true' />
                <span>連携チャットへ送信する</span>
              </label>
            </FormElement>
          </FormListItem>
          {!!report_send_external_service_cooperation && (
            <React.Fragment>
              {this.renderTalkRoomField()}
              {this.renderDirectRoomField()}
            </React.Fragment>
          )}
        </React.Fragment>
      )
    );
  };

  renderTalkRoomField = () => {
    const {
      line_works: { available },
    } = this.props.externalServiceCooperationStatus;
    return (
      available && (
        <FormListItemGroup isBorder={false}>
          <FormListItemChild
            label='LINE WORKS トークルーム'
            required={true}
            requiredText={this.getRequiredText()}
          >
            <FormElement
              validate={_.get(this.props.errors, 'report_lw_talkroom_ids')}
            >
              <DropdownSelector
                label='トークルームを選択'
                multiple={true}
                hasTooltip={true}
                selectorName='report_lw_talkroom_ids'
                options={this.props.lwTalkRooms}
                apiSearchKey=''
                selectedValues={this.state.formData.report_lw_talkroom_ids}
                keyName='name'
                valueName='id'
                apiBindDataKey={'lw_talkrooms'}
                widthClass='dropdown__item'
                onSelect={this.handleSelectRoom}
                onClose={() => {
                  this.props.validate(
                    'report_lw_talkroom_ids',
                    this.state.formData
                  );
                }}
                dropdownSelectStyle={{ width: '238px' }}
              />
            </FormElement>
          </FormListItemChild>
        </FormListItemGroup>
      )
    );
  };

  renderDirectRoomField = () => {
    const {
      direct: { available, reason_code },
    } = this.props.externalServiceCooperationStatus;
    if (
      reason_code === DIRECT_STATUS_CODE.UNAVAILABLE ||
      (available && !this.props.callApiDirectTalkRoomStatus)
    ) {
      return (
        <FormListItemGroup isBorder={false}>
          <FormListItemChild
            label='direct トークルーム'
            required={true}
            requiredText={this.getRequiredText()}
          >
            <FormElement
              validate={_.get(this.props.errors, 'report_direct_talkroom_ids')}
            >
              現在directサービス連携は利用できません。時間をおいて再度お試しください。
            </FormElement>
          </FormListItemChild>
        </FormListItemGroup>
      );
    }
    return (
      <React.Fragment>
        {available && (
          <FormListItemGroup isBorder={false}>
            <FormListItemChild
              label='direct トークルーム'
              required={true}
              requiredText={this.getRequiredText()}
            >
              <FormElement
                validate={_.get(
                  this.props.errors,
                  'report_direct_talkroom_ids'
                )}
              >
                <DropdownSelector
                  label='トークルームを選択'
                  multiple={true}
                  hasTooltip={true}
                  selectorName='report_direct_talkroom_ids'
                  options={this.props.directTalkRooms}
                  apiSearchKey=''
                  selectedValues={
                    this.state.formData.report_direct_talkroom_ids
                  }
                  keyName='name'
                  valueName='talk_id'
                  apiBindDataKey={'direct_talkrooms'}
                  widthClass='dropdown__item'
                  onSelect={this.handleSelectRoom}
                  onClose={() => {
                    this.props.validate(
                      'report_direct_talkroom_ids',
                      this.state.formData
                    );
                  }}
                  dropdownSelectStyle={{ width: '238px' }}
                />
              </FormElement>
            </FormListItemChild>
          </FormListItemGroup>
        )}
      </React.Fragment>
    );
  };

  getRequiredText = () => {
    const { line_works, direct } = this.props.externalServiceCooperationStatus;
    if (
      line_works.available &&
      (direct.available ||
        direct.reason_code === DIRECT_STATUS_CODE.UNAVAILABLE)
    ) {
      return 'どちらか必須';
    }
  };

  render() {
    const showLeftItems =
      !this.state.preview ||
      (this.state.preview && !_.isEmpty(this.state.uploadImages));
    return (
      <div
        className={`SafetyDiaries__items ${
          this.props.isSpace ? 'SafetyDiaries__items--space' : ''
        }`}
      >
        {showLeftItems && (
          <div className='SafetyDiaries__items-left'>
            {this.renderRecoveryImageField()}
          </div>
        )}
        <div
          className={`SafetyDiaries__items-right ${
            !showLeftItems ? 'SafetyDiaries__items-right--no-image' : ''
          }`}
        >
          <FormList>
            {this.renderRecoveryDateField()}
            {this.renderRecoveryContentsField()}
            {!this.state.preview && this.renderNotificationLwField()}
            {this.state.preview && (
              <React.Fragment>
                {this.renderRecoveryUserField()}
                {this.renderRecoveryUpdateTimeField()}
                {this.renderApprovalUserField()}
                {this.renderFinishDateField()}
              </React.Fragment>
            )}
          </FormList>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/SafetyDiaryRecoveryForm.jsx